import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65681c59&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65681c59&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=65681c59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65681c59",
  null
  
)

export default component.exports